<template>
  <select class="form-control font-weight-bold " v-model="valor" @change="$emit('evento', valor)">
    <option v-if="todo" value="Todo">Todo</option>
        <option v-if="todo==undefined" value="">Seleccione</option>
     <option v-for="a in anios"  :key="a" :value="a">{{a}}</option>
   </select>
</template>

<script>
export default {
    name:"aniosComponent",
      props: ['valor_entrada','todo'],
    	data() {
			return {
				anios: [],
                valor: '',
			}
		},
        created(){
             setTimeout(() => {
                this.valor = this.valor_entrada;
            }, 100);
           
            this.anios=this.anosSelect(false,'no');
        },
    methods:{
         anosSelect(actual,combo,order='',quitar_anios=0){
          let fecha = new Date();
          let arrayanos=[];
          let arrayanos2=[];
          let ano = fecha.getFullYear();
          /*arrayanos.push('Todo');*/
             for(let i=ano;i>=2023;i--){
                arrayanos.push(i);
             }
           if(actual && combo=='no'){
             return ano;
           }else if(!actual && combo=='si') {
             return [ano];
           }else{
             if(order=='desc'){
               if(quitar_anios==0){
                  for(let i=2015;i<=ano;i++){
                    arrayanos2.push(i);
                }
               }else{
                for(let i=ano-quitar_anios;i<=ano;i++){
                  arrayanos2.push(i);
              }
               }
                
             return arrayanos2;
             }else{
              return arrayanos;
             }
             
           }
        
         },
    }
}
</script>

